export default __webpack_public_path__ + "a801cacb9c403b2adff5772b72bf396d.png";